import { AuthProviderForm, GenericCredentials } from '../../sessions.service';
import { OAuth2AuthProviderConfig, OAuth2GrantType } from '../oauth2.provider';

/**
 * Implementation of the Username and Password OAuth2 grant type.
 * This class handles the username and password flow for OAuth2 authentication.
 */
export class UsernamePasswordOAuth2GrantType implements OAuth2GrantType {
  /**
   * Returns an array of sign-in fields required for the username and password flow.
   * @returns An array of sign-in fields.
   */
  getSignInFields(): AuthProviderForm {
    return [
      {
        key: 'username',
        label: 'Nome Utente',
        type: 'text',
        saveForPrefill: true,
        icon: 'pi pi-user',
      },
      {
        key: 'password',
        label: 'Password',
        type: 'password',
        saveForPrefill: false,
        icon: 'pi pi-key',
      },
    ];
  }

  /**
   * Prepares the authentication payload for the username and password flow.
   * This method builds the payload for the token request using the provided credentials.
   * @param credentials The generic credentials containing the username and password.
   * @param config The OAuth2 authentication provider configuration.
   * @returns A promise that resolves to the authentication payload.
   */
  async prepareAuthenticationPayload(
    credentials: GenericCredentials,
    config: OAuth2AuthProviderConfig
  ): Promise<BodyInit> {
    const credentialsAreValid = 'username' in credentials && 'password' in credentials;

    if (!credentialsAreValid) {
      throw new Error('[OAuth2][StartSession]Username or password not specified');
    }

    const formData = new URLSearchParams();
    formData.append('grant_type', 'password');
    formData.append('client_id', config.clientId);
    if (config.clientSecret !== undefined) {
      formData.append('client_secret', config.clientSecret);
    }
    formData.append('username', credentials['username']);
    formData.append('password', credentials['password']);
    return formData;
  }
}
